<template>
  <div>
   <div class="grid-row">
    <div class=" titulo-grid">
      Informações da Tarefa
    </div>
  </div>
  <div class="grid-row">
    <div class=" titulo">
      Tarefa
    </div>
    <div class="">
      {{ dadosFichaTecnica.pco_tarefa.ctrl_tarefa.tarefa }}
    </div>
    <div class=" titulo">
      Usuário Responsável
    </div>
    <div class="">
      {{ (dadosFichaTecnica.pco_tarefa.user_tratamento)?dadosFichaTecnica.pco_tarefa.user_tratamento.name:'' }}
    </div>
  </div>
  <div class="grid-row">
    <div class="">
    </div>
    <div class="">
    </div>
    <div class="titulo">
      Telefone Responsável
    </div>
    <div class="">
      {{ (dadosFichaTecnica.pco_tarefa.user_tratamento)
      ? (dadosFichaTecnica.pco_tarefa.user_tratamento.telefone_1 ? dadosFichaTecnica.pco_tarefa.user_tratamento.telefone_1 : '-')
      : '-' }}
    </div>
  </div>
 </div>  
</template>

<script>

export default {
  name: "InformacoesTarefaComponent",
  props: {
    dadosFichaTecnica: {
      type: Array,
      required: true
    }
  },
  
}
</script>